import styled from 'styled-components'

export const NavContainer = styled.div`
display: flex;
align-items: center;
justify-content: center;
width: 100%;
box-sizing: border-box;
z-index: 3;
background-image: linear-gradient(to right, rgb(114, 143, 251), rgb(232, 150, 177) 98%);

&.mobile-view{
  position: fixed;
    bottom: 0;
    border-top-left-radius: 19px;
    border-top-right-radius: 19px;
    z-index:10;
}

@media (max-width: 1280px){
  padding: 15px 5% 15px 5%;
}
@media (max-width: 600px){
  padding: 5%;

}
@media (min-width: 1281px){
  padding: 15px 20% 15px 20%;
}
`


export const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  height: 10px;

  &.main-version-switch{
    position: absolute;
    left:5%;
    top: 3vh;

  }
`

export const PurchaseOptionBox = styled.div`
  border-radius:30px;
  background-color: #927cff;
  width: 100%;
  padding: 2% 5%;
  margin-top:3%;
  cursor: pointer;
  transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  box-sizing: border-box;

  @media (max-width: 600px){
    padding: 5%;
  }


  &.select-option{
    min-height: 700px;
    height:70vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;


  }

  &:hover{
    transform: scale(1.05);
  }

  &.tablet-view{
    @media (orientation: portrait){
      height: auto;
    }
    @media (orientation: landscape){
      height: 45vh;
      width: 40vw;
    }
  }

`
export const ModalContainer = styled.div`
  width: 100%;
  height: 100%;
  background-image: linear-gradient(to right,rgba(114,143,251,0.7),rgba(232,150,177,0.7) 98%);
  padding: 7% 5%;
  border-radius: 30px;
  display: flex;
  flex-direction: column;
  position: relative;

  /* background: rgba( 255, 255, 255, 0.25 ); */
box-shadow: 0 8px 32px 0 rgba( 31, 38, 135, 0.37 );
backdrop-filter: blur( 4px );
-webkit-backdrop-filter: blur( 8px );
`
